module.exports = __webpack_public_path__ + "img/temperature_blue.b7099d40.svg";